module.exports = __webpack_public_path__ + "static/Theinhardt-Bold-d3004436e08003ee0aeaf6256a5bebe3.otf";